import { auth, db } from '../config/firebase';
import { collection, doc, getDoc, addDoc, serverTimestamp } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';

// Test function to check user roles and create an event
export const testEventCreation = async () => {
  return new Promise((resolve, reject) => {
    onAuthStateChanged(auth, async (user) => {
      if (!user) {
        console.log('❌ No user is signed in');
        reject(new Error('No user is signed in'));
        return;
      }

      try {
        // 1. Check user roles
        console.log('👤 Checking user roles...');
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        
        if (!userDoc.exists()) {
          console.log('❌ User document not found');
          reject(new Error('User document not found'));
          return;
        }

        const userData = userDoc.data();
        console.log('📋 User roles:', userData.roles);
        
        const isOrganizer = userData.roles?.includes('organizer');
        const isAdmin = userData.roles?.includes('admin');

        if (!isOrganizer && !isAdmin) {
          console.log('❌ User does not have organizer or admin role');
          reject(new Error('User does not have required roles'));
          return;
        }

        // 2. Create a test event
        console.log('📝 Creating test event...');
        const testEvent = {
          title: 'Test Event ' + new Date().toISOString(),
          description: 'This is a test event to verify event creation',
          startDateTime: new Date(),
          endDateTime: new Date(Date.now() + 3600000), // 1 hour from now
          location: {
            address: 'Test Location',
            lat: 0,
            lng: 0
          },
          category: 'Test',
          imageUrl: 'https://via.placeholder.com/150',
          organizerId: user.uid,
          organizerName: user.displayName || 'Test Organizer',
          status: 'published',
          capacity: 100,
          ticketTiers: [{
            name: 'General Admission',
            price: 10,
            quantity: 100,
            description: 'General admission ticket',
            sold: 0
          }],
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        };

        // 3. Add the event to Firestore
        const eventRef = await addDoc(collection(db, 'events'), testEvent);
        console.log('✅ Test event created successfully with ID:', eventRef.id);

        // 4. Verify the event was created
        const eventDoc = await getDoc(doc(db, 'events', eventRef.id));
        if (eventDoc.exists()) {
          console.log('✅ Event verified in database');
          resolve({
            success: true,
            eventId: eventRef.id,
            userData: userData
          });
        } else {
          console.log('❌ Event not found after creation');
          reject(new Error('Event not found after creation'));
        }

      } catch (error) {
        console.error('❌ Error during test:', error);
        reject(error);
      }
    });
  });
};

// Export a function to run the test
export const runEventCreationTest = async () => {
  try {
    const result = await testEventCreation();
    console.log('🎉 Test completed successfully:', result);
    return result;
  } catch (error) {
    console.error('💥 Test failed:', error);
    throw error;
  }
}; 